import { createStandaloneToast } from '@chakra-ui/react';
import theme from 'theme/theme';

const customToast = createStandaloneToast({
	theme: theme,
});

export default customToast;
